import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Box, Button,
} from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';
import {
  INPUT, UPLOAD_COMPANY_TAB, PROCESS_STATUS,
} from '../../../common/const';
import UploadSettingComponent from './UploadSettingComponent';
import UploadResultComponent from './UploadResultComponent';
import {
  setSystemLodingFLg,
  setInitMessage,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  setDispTab,
  fileUploadExecute,
  updateExecute,
  searchUploadJobList,
  filterJobList,
  setErrorFileId,
} from '../../actions/UploadAction';
import styles from './UploadAreaComponent.module.css';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import config from '../../../common/config';
import MyIcon from '../common/MyIcon';

class UploadAreaComponent extends Component {
  /**
 * タブ切り替え
 */
  tabClick = (newTab) => {
    const { setDispTabAct } = this.props;
    setDispTabAct(newTab);
  }

  /**
 * アップロード実行
 */
  onclickUploadButton = async () => {
    const {
      setInitMessageAct,
      setErrorMessageAct,
      fileUploadExecuteAct,
      charCode,
      setErrorFileIdAct,
      additionalItemsIdList,
    } = this.props;

    // ファイル情報取得
    // 取引情報ファイル
    const additionalItemsFileList = new Map();
    additionalItemsIdList.forEach((id) => {
      const additionalItemsFile = document.getElementById(id).files[0];
      if (additionalItemsFile) {
        additionalItemsFileList.set(id, additionalItemsFile);
      }
    });

    // ファイル名リスト
    const fileNameList = [];
    additionalItemsFileList.forEach((file) => fileNameList.push(file.name));

    // 重複ファイル名リスト
    const errorFileNameList = Array.from(new Set(
      fileNameList.filter((fileName, i, self) => self.indexOf(fileName) !== i),
    ));

    // メッセージエリア初期化
    setInitMessageAct();
    const msgs = [];
    const errorIdList = [];

    // ファイル形式チェック
    // 取引情報
    if (additionalItemsFileList.size > 0) {
      additionalItemsFileList.forEach((additionalItemsFile, id) => {
        const isError = this.validatorFile(
          INPUT.UPLOAD.ADDITIONAL_ITEMS_FILE, additionalItemsFile, msgs, id,
        );
        const isNameError = errorFileNameList.includes(additionalItemsFile.name);
        if (isError || isNameError) {
          errorIdList.push(id);
        }
      });
    } else {
      // 未選択の場合
      this.validatorFile(INPUT.UPLOAD.ADDITIONAL_ITEMS_FILE, '', msgs);
      // 全レコードをエラー
      errorIdList.push(...additionalItemsIdList);
    }

    // this.setState({ errorFileIdList: errorIdList });
    setErrorFileIdAct(errorIdList);

    // ファイル名重複チェック
    if (errorFileNameList.length > 0) {
      errorFileNameList.forEach((fileName) => {
        msgs.push(<div key={fileName}>{getMessage(ERROR.E08020, fileName)}</div>);
      });
    }

    if (msgs.length > 0) {
      // チェックエラーの場合、エラーメッセージを表示
      setErrorMessageAct(msgs);
      return;
    }

    // ファイルアップロード
    await fileUploadExecuteAct(
      additionalItemsFileList, charCode,
    );
  }

  /**
 * ファイル形式チェック
 */
  validatorFile = (name, file, msgs, key = name) => {
    const i = msgs.length;
    validator.checkFileStatus(
      name,
      file,
      config.FILE_SIZE_LIMIT.UPLOAD_COMPANY,
      VALIDATOR_CONST.PATERN_CSV,
      config.FILE_NAME_LIMIT.UPLOAD_COMPANY,
      msgs,
      key,
    );
    return i !== msgs.length;
  }

  /**
 * データ確定
 */
  onclickDataUploadButton = async () => {
    const {
      setSystemLodingFLgAct,
      updateExecuteAct,
      searchUploadJobListAct,
      selectJob,
      filterJobListAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // アップロード実行
    const ret = await updateExecuteAct();
    if (ret) {
      // ジョブ一覧をシステム日時で再取得
      await searchUploadJobListAct(selectJob.excution_date);
      // ジョブ一覧から対象ジョブを抽出
      filterJobListAct();
    }
    setSystemLodingFLgAct(false);
  }

  /**
 * 更新
 */
  onclickUpdateButton = async () => {
    const {
      setSystemLodingFLgAct,
      searchUploadJobListAct,
      selectJob,
      filterJobListAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ジョブ一覧を選択ジョブの処理実行日で再取得
    await searchUploadJobListAct(selectJob.excution_date);
    // ジョブ一覧から対象ジョブを抽出
    filterJobListAct();
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      dispTab,
      selectSequenceId,
      selectJob,
    } = this.props;

    let uploadButton;
    if (dispTab === UPLOAD_COMPANY_TAB.SETTING) {
      uploadButton = (
        <Box>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => this.onclickUploadButton()}
            startIcon={<MyIcon className={`${styles.uploadIcon}`} type="upload" />}
            className={`${styles.btnSize}`}
          >
            アップロード実行
          </Button>
        </Box>
      );
    }

    let dataConfirmedButton;
    if (dispTab === UPLOAD_COMPANY_TAB.RESULT && selectJob.status === PROCESS_STATUS.CHECK_OK) {
      dataConfirmedButton = (
        <Box>
          <div className={`${styles.baloon}`}>
            <div className={`${styles.triangle}`}>
              <div className={`${styles.triangleDiv}`} />
            </div>
            <div className={`${styles.babble}`}>
              <span>
                ボタン押下することで
                <br />
                アップロードデータを確定します
              </span>
            </div>
          </div>
          <Box>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.onclickDataUploadButton()}
              startIcon={<MyIcon className={`${styles.uploadIcon}`} type="upload" />}
              className={`${styles.btnSize}`}
            >
              データ確定
            </Button>
          </Box>
        </Box>
      );
    }

    let updateButton;
    if (dispTab === UPLOAD_COMPANY_TAB.RESULT && selectJob.status === PROCESS_STATUS.PROCESSING) {
      updateButton = (
        <Box>
          <Button
            variant="contained"
            onClick={() => this.onclickUpdateButton()}
            startIcon={<Autorenew />}
            className={`${styles.btnSize} addAll`}
          >
            更新
          </Button>
        </Box>
      );
    }

    return (
      <Box>
        <Box className={`${styles.uploadAreaHeader}`} display="flex" justifyContent="space-between">
          <div className="tabGroup">
            <Button
              className={[
                `${styles.tabSize} tab`,
                dispTab === UPLOAD_COMPANY_TAB.SETTING ? 'selected' : null,
              ].join(' ')}
              onClick={() => {
                this.tabClick(UPLOAD_COMPANY_TAB.SETTING);
              }}
              tabIndex="-1"
            >
              取引情報アップロード設定
            </Button>
            <Button
              className={[
                `${styles.tabSize} tab`,
                dispTab === UPLOAD_COMPANY_TAB.RESULT ? 'selected' : null,
                selectSequenceId ? null : 'disabled',
              ].join(' ')}
              onClick={() => {
                this.tabClick(UPLOAD_COMPANY_TAB.RESULT);
              }}
              disabled={!selectSequenceId}
              tabIndex="-1"
            >
              取引情報アップロード結果
            </Button>
          </div>
          {uploadButton}
          {dataConfirmedButton}
          {updateButton}
        </Box>
        {dispTab === UPLOAD_COMPANY_TAB.SETTING
          ? <UploadSettingComponent />
          : <UploadResultComponent />}
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    dispTab: state.upload.dispTab,
    selectSequenceId: state.upload.selectSequenceId,
    charCode: state.upload.charCode,
    selectJob: state.upload.selectJob,
    errorFileIdList: state.upload.errorFileIdList,
    additionalItemsIdList: state.upload.additionalItemsIdList,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    updateExecuteAct: () => dispatch(updateExecute()),
    setErrorMessageAct: (errorMessage) => dispatch(setErrorMessage(errorMessage)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    searchUploadJobListAct: (excutionDate) => dispatch(searchUploadJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
    setErrorFileIdAct: (obj) => dispatch(setErrorFileId(obj)),
    fileUploadExecuteAct: (
      additionalItemsFile,
    ) => dispatch(fileUploadExecute(
      additionalItemsFile,
    )),
  }),
)(UploadAreaComponent);
